import React, { useState } from 'react';
import { redeemAccessCode } from '../lib/callables.js';
import { useAuth } from '../auth/useAuth.js';
import { accessCodeErrorMessage, accessCodeResultMessage } from './accessCodeMessages.js';

export default function AccessCodeRedeemer() {
    const { currentUser } = useAuth();
    const [code, setCode] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const redeem = async e => {
        e.preventDefault(); setBusy(true); setMessage('');
        try {
            await currentUser?.reload();
            await currentUser?.getIdToken(true);
            const result = await redeemAccessCode({ code });
            setMessage(accessCodeResultMessage(result));
            setCode('');
        } catch (e) { setMessage(accessCodeErrorMessage(e)); }
        finally { setBusy(false); }
    };
    return <details className="my-6 border border-burgundy-accent/20 rounded-2xl bg-burgundy-page p-5">
        <summary className="cursor-pointer font-display text-burgundy-accent">Have an access or extension code?</summary>
        <p className="text-sm text-burgundy-muted mt-3">Redeem Danielle’s invitation here after verifying your email. No payment or card required. Free-access codes keep existing active access unchanged; extension codes add the offer’s stated time to your valid personal term, or start from redemption if it has ended. Normal AI limits apply.</p>
        <form onSubmit={redeem} className="flex flex-wrap gap-3 mt-3">
            <label className="flex-grow"><span className="sr-only">Access code</span><input aria-label="Access code" value={code} onChange={e => setCode(e.target.value.toUpperCase())} maxLength={32} required placeholder="Enter access code" className="w-full border rounded-lg bg-burgundy-bg text-burgundy-text p-3" /></label>
            <button disabled={busy || !code.trim()} className="bg-burgundy-accent text-burgundy-pageDark px-5 py-3 rounded-full disabled:opacity-50">{busy ? 'Redeeming…' : 'Redeem access'}</button>
        </form>
        {message && <p role="status" className="text-sm text-burgundy-text mt-3">{message}</p>}
    </details>;
}
